__turbopack_context__.v({
  "accordion": "FAQ-module-scss-module__Rn97Iq__accordion",
  "closeButton": "FAQ-module-scss-module__Rn97Iq__closeButton",
  "content": "FAQ-module-scss-module__Rn97Iq__content",
  "endCard": "FAQ-module-scss-module__Rn97Iq__endCard",
  "fade-in": "FAQ-module-scss-module__Rn97Iq__fade-in",
  "faqPage": "FAQ-module-scss-module__Rn97Iq__faqPage",
  "faqPage--isDetail": "FAQ-module-scss-module__Rn97Iq__faqPage--isDetail",
  "isActive": "FAQ-module-scss-module__Rn97Iq__isActive",
  "isFlushTop": "FAQ-module-scss-module__Rn97Iq__isFlushTop",
  "isOpen": "FAQ-module-scss-module__Rn97Iq__isOpen",
  "isSticky": "FAQ-module-scss-module__Rn97Iq__isSticky",
  "label": "FAQ-module-scss-module__Rn97Iq__label",
  "loader": "FAQ-module-scss-module__Rn97Iq__loader",
  "navCaret": "FAQ-module-scss-module__Rn97Iq__navCaret",
  "openButton": "FAQ-module-scss-module__Rn97Iq__openButton",
  "questionsEmpty": "FAQ-module-scss-module__Rn97Iq__questionsEmpty",
  "sideLink": "FAQ-module-scss-module__Rn97Iq__sideLink",
  "sideNav": "FAQ-module-scss-module__Rn97Iq__sideNav",
  "sideNavAbsInner": "FAQ-module-scss-module__Rn97Iq__sideNavAbsInner",
  "sideNavAbsInnerBack": "FAQ-module-scss-module__Rn97Iq__sideNavAbsInnerBack",
  "sideNavContainer": "FAQ-module-scss-module__Rn97Iq__sideNavContainer",
  "sideNavGroup": "FAQ-module-scss-module__Rn97Iq__sideNavGroup",
  "sideNavHeader": "FAQ-module-scss-module__Rn97Iq__sideNavHeader",
  "sideNavInner": "FAQ-module-scss-module__Rn97Iq__sideNavInner",
  "subNav": "FAQ-module-scss-module__Rn97Iq__subNav",
  "subNavPage": "FAQ-module-scss-module__Rn97Iq__subNavPage",
  "title": "FAQ-module-scss-module__Rn97Iq__title",
});
